import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";

const Dropdown = ({children, btnText = "Acciones", btnIcon, classes = {}, styles = {}, fixed = false}) => {
	const wrapperRef = useRef();
	const [open, setOpen] = useState(false);
	const [position, setPosition] = useState({ top: 0, right: 0 });

	if (!fixed) {
		return (
			<div className={`dropdown ${classes.dropdown}`} style={styles.dropdown}>
				<button className={`au-btn au-btn-icon au-btn-filter ${classes.button}`} style={styles.button}>
					{btnIcon} {btnText}
				</button>
				<div
					style={styles.dropdownMenu}
					className={`dropdown-menu ${classes.dropdownMenu}`}
				>
					{children}
				</div>
			</div>
		);
	}

	const openMenu = () => {
		const rect = wrapperRef.current.getBoundingClientRect();
		setPosition({
			top: rect.bottom,
			right: window.innerWidth - rect.right,
		});
		setOpen(true);
	};

	const closeMenu = () => setOpen(false);

	return (
		<div
			ref={wrapperRef}
			className={`dropdown ${classes.dropdown}`}
			style={styles.dropdown}
			onMouseEnter={openMenu}
			onMouseLeave={closeMenu}
		>
			<button className={`au-btn au-btn-icon au-btn-filter ${classes.button}`} style={styles.button}>
				{btnIcon} {btnText}
			</button>
			{open && createPortal(
				// position: fixed (anchored to the viewport, not to the scroll
				// container) so an open menu never widens the table's scrollable
				// area — absolutely positioned menus do even off-screen.
				<div
					onMouseEnter={openMenu}
					onMouseLeave={closeMenu}
					style={{
						...styles.dropdownMenu,
						position: "fixed",
						top: position.top,
						right: position.right,
						left: "auto",
						display: "block",
						zIndex: 1050,
					}}
					className={`dropdown-menu ${classes.dropdownMenu}`}
				>
					{children}
				</div>,
				document.body
			)}
		</div>
	);
};

export default Dropdown;
